'use client';

import styled from 'styled-components';

import { colors, breakpoints } from '@/styles/theme';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  height: 100%;
  padding: 20px 60px;
  gap: 10px;

  color: ${colors.dark};
  background-color: ${colors.light};
  border-radius: 10px;

  @media (max-width: ${breakpoints.laptop}) {
    padding: 20px 50px;
  }
`;

export const Title = styled.div`
  font-size: 60px;
  font-weight: 700;
  letter-spacing: -2px;

  @media (max-width: ${breakpoints.mobile}) {
    font-size: 40px;
  }
`;

export const InfoText = styled.div`
  text-transform: ${({ $caps }) => ($caps ? 'uppercase' : null)};
  font-size: ${({ $caps }) => ($caps ? '26px' : null)};
  text-align: ${({ $centered }) => ($centered ? 'center' : null)};
  color: ${({ $colored }) => ($colored ? colors.simba : null)};

  @media (max-width: ${breakpoints.mobile}) {
    font-size: ${({ $caps }) => ($caps ? '20px' : '14px')};
  }
`;

export const BarCode = styled.div`
  margin: 0 auto;
`;
